module.exports = __webpack_public_path__ + "img/droadheader.e9c7a3a7.jpg";